import React from "react";
import { Video } from "../../types/Video";
import "./VideoInfoSection.css";

/// プレイヤー状態の型定義
interface PlayerState {
  videoId: string;
  currentTime: number;
  duration: number;
  state: "UNSTARTED" | "ENDED" | "PLAYING" | "PAUSED" | "BUFFERING" | "CUED";
}

/// VideoInfoSectionのProps型定義
interface VideoInfoSectionProps {
  currentVideo: Video | null;
  viewerCount: number;
  connectionStatus:
    | "connecting"
    | "connected"
    | "disconnected"
    | "reconnecting";
  playerState: PlayerState;
}

/// 秒数を時分秒形式に変換する関数（HH:MM:SS または MM:SS）
const formatTime = (seconds: number): string => {
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const remainingSeconds = Math.floor(seconds % 60);

  // 1時間以上の場合は HH:MM:SS 形式
  if (hours > 0) {
    return `${hours}:${String(minutes).padStart(2, "0")}:${String(
      remainingSeconds
    ).padStart(2, "0")}`;
  }

  // 1時間未満の場合は MM:SS 形式
  return `${minutes}:${String(remainingSeconds).padStart(2, "0")}`;
};

/// 接続状態の表示テキストとアイコンを取得
const getConnectionStatusDisplay = (status: string) => {
  switch (status) {
    case "connecting":
      return { text: "接続中..." };
    case "connected":
      return { text: "ライブ" };
    case "disconnected":
      return { text: "切断" };
    case "reconnecting":
      return { text: "再接続中..." };
    default:
      return { text: "未接続" };
  }
};

const VideoInfoSection: React.FC<VideoInfoSectionProps> = ({
  currentVideo,
  viewerCount,
  connectionStatus,
  playerState,
}) => {
  const connectionDisplay = getConnectionStatusDisplay(connectionStatus);

  return (
    <section className="video-info-section">
      {/* 動画タイトル */}
      <h2 className="video-info__title">
        {currentVideo?.title || "動画を読み込み中..."}
      </h2>

      {/* メタ情報 */}
      <div className="video-info__meta">
        {/* 視聴人数 */}
        <span className="video-info__viewers">{viewerCount}人が視聴中</span>

        {/* 接続状態 */}
        <span
          className={`video-info__status video-info__status--${connectionStatus}`}
        >
          {connectionDisplay.text}
        </span>

        {/* 再生時間・状態 */}
        {playerState.duration > 0 && (
          <>
            <span className="video-info__time">
              {formatTime(playerState.currentTime)} /{" "}
              {formatTime(playerState.duration)}
            </span>
          </>
        )}
      </div>
    </section>
  );
};

export default VideoInfoSection;
